import { Injectable } from '@angular/core';
import {MapPosition} from "../../models/MapPosition";

// todo: create adapter for Google

@Injectable({
  providedIn: 'root'
})
export class GeoLibService {

  private _gecoder = null;
  get geocoder() {
    if (this._gecoder === null) {
      this._gecoder = new window['google'].maps.Geocoder();
    }
    return this._gecoder;
  }

  constructor() { }

  geocode(position: MapPosition) {
    return new Promise((resolve, reject) => {
      if (!window['GOOGLE_READY']) {
        console.error("Geocoding service is not available");
        return resolve(null);
      }
      this.geocoder.geocode({ location: {lat: position.lat, lng: position.lng} }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            console.log('geocode:', results);
            let country = null;
            for (let i = 0; i < results[0].address_components.length; i++) {
              let c = results[0].address_components[i];
              if (c.types.indexOf('country') >= 0) {
                country = c.short_name;
                break;
              }
            }
            return resolve({ // todo: make GeocodeResult class
              country: country,
              address: results[0].formatted_address
            });
          } else {
            return resolve(null);
          }
        } else {
          console.error("Geocoder failed due to: " + status);
          return resolve(null);
        }
      });
    });
  }

  computeArea(path: MapPosition[]) {
    if (!window['GOOGLE_READY']) {
      console.error("Geometry service is not available");
      return 0;
    }
    return window['google'].maps.geometry.spherical.computeArea(path.map(p => new window['google'].maps.LatLng(p.asSimpleObject())));
  }
}
